import { Layers } from "appworks/graphics/layers/layers";
import { BackgroundMusicToggleControl } from "appworks/ui/controls/standard/toggle/background-music-toggle-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";

export class BackgroundMusicToggleControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiToggle("background_music")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new BackgroundMusicToggleControl(layer.getFlexiToggle("background_music"))];
    }
}
